import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { NeptuneApi } from '../genericApi/neptune.api';
import { GoogleAnalyticsReportRequestModel } from './models/google-analytics-report.request';
import { GoogleAnalyticsReportResponseModel } from './models/google-analytics-report.response';

@Injectable()
export class ExternalDataApi {
    constructor(
        private neptuneApi: NeptuneApi
    ) {}

    /**
     * Gets a list of limited report information
     */
    public getGoogleAnalyticsData(
        dataConnectorId: number,
        profileId: string,
        query: GoogleAnalyticsReportRequestModel
    ): Observable<GoogleAnalyticsReportResponseModel> {
        return this.neptuneApi.api<GoogleAnalyticsReportResponseModel>(
            `/externaldata/googleanalytics/dataconnectors/${dataConnectorId}/profiles/${profileId}`,
            query,
            HttpVerbsEnum.POST
        );
    }
}
